export default "__VITE_ASSET__C4DFH0t5__"